import * as React from "react";
import AdvancedTable, { TableColumnDefinition } from "../AdvancedTable";
import styles from "./reportsTable.module.scss";

export interface ReportsTableProps {
    columnDefinitions: TableColumnDefinition[];
    rows: {}[];
}

const ReportsTable = (props: ReportsTableProps) => {
    return (
        <div className={styles.tableWrapper}>
            <AdvancedTable columns={props.columnDefinitions} rows={props.rows} />
        </div>
    );
};

export default ReportsTable;
